import script from "./ProductAttributes.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductAttributes.vue?vue&type=script&setup=true&lang=js"

import "./ProductAttributes.vue?vue&type=style&index=0&id=350d9434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350d9434"]])

export default __exports__